import React, { useState } from "react";
import SettingFamilyCard from "../SettingFamilyCard/SettingFamilyCard";
import editPen from "../../assets/images/svg/editPen.svg";
import settingPhone1 from "../../assets/images/svg/settingPhone1.svg";
import settingMail1 from "../../assets/images/svg/settingMail1.svg";
import ToggleButton from "../ToggleButton/ToggleButton";
import { useNavigate } from "react-router";
import { Observer, observer } from "mobx-react";
import NoImage from "../NoImage/NoImage";
import Modal from "../Modal";
import SettingPermitModal from "../SettingPermitModal/SettingPermitModal";
import AuthStore from "../../store/AuthStore";
import SettingsStore from "../../store/SettingsStore";
import { ReactComponent as HomePagePopupIcon } from "../../assets/images/svg/homePagePopupIcon.svg";
import ArrowButton from "../ArrowButton";
import { familyOfficeTeamNameText } from "../../utils/constants";

const AddedLiaisonOfficer = observer(() => {
  const [disableAccessModal, setDisableAccessModal] = useState(false);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [userType, setUserType] = useState("");
  const [userData, setUserData] = useState([]);
  const [toggleConfig, setToggleConfig] = useState();
  const [isToggleDisable] = useState({
    user21Istoggle: false,
    user22Istoggle: false,
    user23Istoggle: false,
    user24Istoggle: false,
  });
  const [isAllDis] = useState(false);
  const navigate = useNavigate();

  const toggle = (data) => {
    const liaisonOfficerData = SettingsStore?.liaisonOfficerData;
    if (data.length === 1) {
      const accountAccess = liaisonOfficerData.accountAccess.map(
        (familyMember) => {
          if (familyMember.client.user_id === data[0].client.user_id) {
            return {
              accessEnabled: !data[0].accessEnabled,
              client: {
                user_id: familyMember.client.user_id,
              },
            };
          } else {
            return {
              accessEnabled: familyMember.accessEnabled,
              client: {
                user_id: familyMember.client.user_id,
              },
            };
          }
        }
      );
      const payload = { AccountAccess: accountAccess };
      if (
        liaisonOfficerData.accountAccess
          .map((eachClient) => !eachClient.AccessEnabled)
          .every(Boolean)
      ) {
        payload.AccessEnabled = true;
      } else {
        payload.AccessEnabled = liaisonOfficerData.accessEnabled;
      }
      payload.Profile = {
        full_name: liaisonOfficerData.profile.full_name,
        PhoneNo: liaisonOfficerData.profile.phoneNo,
        EmailId: liaisonOfficerData.profile.emailId,
      };
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      SettingsStore.callUpdateLaisonOfficerData(
        liaisonOfficerData.profile.id,
        payload
      );
    } else if (
      data.length > 1 &&
      data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
    ) {
      const accountAccess = data.map((familyMember) => {
        return {
          accessEnabled: false,
          client: {
            user_id: familyMember.client.user_id,
          },
        };
      });
      const payload = { AccountAccess: accountAccess };
      payload.AccessEnabled = liaisonOfficerData.accessEnabled;
      payload.Profile = {
        full_name: liaisonOfficerData.profile.full_name,
        PhoneNo: liaisonOfficerData.profile.phoneNo,
        EmailId: liaisonOfficerData.profile.emailId,
      };
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      SettingsStore.callUpdateLaisonOfficerData(
        SettingsStore?.liaisonOfficerData.profile.id,
        payload
      );
    }
    setDisableAccessModal(false);
  };

  const handleToggle = (e, data) => {
    const { name } = e.target;

    if (name !== "All") {
      setUserData([data]);
      setToggleConfig(!data.accessEnabled);
      setUserType(name);
      setDisableAccessModal(true);
    } else if (
      data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
    ) {
      setUserType("All");
      setUserData(data);
      setToggleConfig(isAllDis);
      setDisableAccessModal(true);
    } else if (
      data.length > 1 &&
      !data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
    ) {
      const liaisonOfficerData = SettingsStore?.liaisonOfficerData;
      const accountAccess = data.map((familyMember) => {
        return {
          accessEnabled: true,
          client: {
            user_id: familyMember.client.user_id,
          },
        };
      });
      const payload = { AccountAccess: accountAccess };
      if (
        liaisonOfficerData.accountAccess
          .map((eachClient) => !eachClient.AccessEnabled)
          .every(Boolean)
      ) {
        payload.AccessEnabled = true;
      } else {
        payload.AccessEnabled = liaisonOfficerData.accessEnabled;
      }
      payload.Profile = {
        full_name: liaisonOfficerData.profile.full_name,
        PhoneNo: liaisonOfficerData.profile.phoneNo,
        EmailId: liaisonOfficerData.profile.emailId,
      };
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      SettingsStore.callUpdateLaisonOfficerData(
        SettingsStore?.liaisonOfficerData.profile.id,
        payload
      );
    }
  };

  const handleLiaisonOfficerToggle = () => {
    const liaisonOfficerData = SettingsStore?.liaisonOfficerData;
    const accountAccess = liaisonOfficerData.accountAccess.map(
      (familyMember) => {
        return {
          AccessEnabled: familyMember.accessEnabled,
          client: {
            user_id: familyMember.client.user_id,
          },
        };
      }
    );
    const payload = { AccountAccess: accountAccess };
    payload.AccessEnabled = !liaisonOfficerData.accessEnabled;
    payload.Profile = {
      full_name: liaisonOfficerData.profile.full_name,
      PhoneNo: liaisonOfficerData.profile.phoneNo,
      EmailId: liaisonOfficerData.profile.emailId,
    };
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    SettingsStore.callUpdateLaisonOfficerData(
      SettingsStore?.liaisonOfficerData.profile.id,
      payload
    );
  };

  const getCharactersArr = (nameStr) => {
    const nameArr = nameStr?.split(" ");
    if (nameArr && nameArr.length > 1) {
      return [nameArr[0][0], nameStr?.slice(nameStr?.lastIndexOf(" ") + 1)[0]];
    } else {
      return [nameArr[0], ""];
    }
  };

  const getAllMembersImageData = () => {
    return userData.map((eachClientObj) => {
      return {
        title: eachClientObj.client.full_name,
        image:
          SettingsStore.liaisonOfficerImages?.[eachClientObj.client.user_id],
      };
    });
  };

  const handleLiaison = (e, data) => {
    const liaisonOfficerData = SettingsStore?.liaisonOfficerData;
    const { name } = e.target;
    const liaisonData = [
      {
        client: {
          full_name: liaisonOfficerData.profile.full_name,
          profile_pic: liaisonOfficerData?.profile?.profile_pic,
          user_id: liaisonOfficerData?.profile?.user_id,
        },
      },
    ];
    setUserType(name);
    setUserData(liaisonData);
    setToggleConfig(!SettingsStore?.liaisonOfficerData?.accessEnabled);
    setDisableAccessModal(true);
  };

  const handleLiaisonConfirm = () => {
    if (!toggleConfig) handleLiaisonOfficerToggle();
    else {
      setDisableAccessModal(false);
      setOpenInfoModal(true);
    }
  };

  return (
    <Observer>
      {() => (
        <>
          <div className="added_liason_outer">
            <h2 className="heading_lia blueTextColor">
              Add or Remove your Family Account Manager to your account to view
              your portfolio and{" "}
              <span className="blueTextColor">
                Enable Views for your Family Account Manager
              </span>
            </h2>
            <div className="user_info_div blueBordertColor">
              {SettingsStore?.liaisonOfficerData?.profile?.profile_pic &&
              SettingsStore.liaisonOfficerImages?.[
                SettingsStore?.liaisonOfficerData?.profile?.user_id
              ] ? (
                <img
                  disabled
                  src={
                    SettingsStore.liaisonOfficerImages
                      ? SettingsStore.liaisonOfficerImages?.[
                          SettingsStore?.liaisonOfficerData?.profile?.user_id
                        ]
                      : null
                  }
                  alt="officer"
                />
              ) : (
                <NoImage
                  data={getCharactersArr(
                    SettingsStore?.liaisonOfficerData?.profile?.full_name
                  )}
                  noImageClass={"no_image_setting"}
                />
              )}
              <div className="data_containt">
                <h2>{SettingsStore?.liaisonOfficerData?.profile?.full_name}</h2>
                <h2>
                  <img src={settingPhone1} alt="" />
                  <span>
                    +91 {SettingsStore?.liaisonOfficerData?.profile?.phoneNo}
                  </span>
                </h2>
                <h2>
                  <img src={settingMail1} alt="" />
                  <span>
                    {SettingsStore?.liaisonOfficerData?.profile?.emailId}
                  </span>
                </h2>
              </div>
              <div
                className="editpen"
                onClick={() => navigate("/settings/edit-family-office-team")}
              >
                <img src={editPen} alt="" /> <h2>Edit Details</h2>
              </div>
              <ToggleButton
                name="liaison"
                isToggleDisable={
                  !SettingsStore?.liaisonOfficerData?.accessEnabled
                }
                handleToggle={
                  (e, data) => handleLiaison(e, data)
                  //() => setDisableAccessModal(true)
                  //handleLiaisonOfficerToggle
                }
              />
            </div>
            <SettingFamilyCard
              isAllDis={
                SettingsStore?.liaisonOfficerData?.accountAccess
                  ? SettingsStore?.liaisonOfficerData?.accountAccess
                      .map((familyMember) => familyMember.accessEnabled)
                      .every(Boolean)
                  : false
              }
              isToggleDisable={isToggleDisable}
              family_data={SettingsStore?.liaisonOfficerData?.accountAccess}
              getFamilyMemberImageFrom={SettingsStore.liaisonOfficerImages}
              handleToggle={(e, data) => handleToggle(e, data)}
              borderObje={{
                borderTopLeftRadius: "0px",
                borderTopRightRadius: "0px",
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
                width: "762px",
              }}
            />
          </div>
          <Modal
            onClose={() => setDisableAccessModal(false)}
            open={disableAccessModal}
            width="453px"
            minWidth="453px"
            modalContainerClass="disable_liasion_access_modal"
          >
            <SettingPermitModal
              userType1={userType}
              data={userData}
              getFamilyMemberImageFrom={SettingsStore.liaisonOfficerImages}
              isToggleDisable={toggleConfig}
              type={"access"}
              onClose={() => setDisableAccessModal(false)}
              userType={`your ${familyOfficeTeamNameText} Access`}
              // userType={
              //   userType !== "liaison"
              //     ? "your Family Member Access"
              //     : `your ${familyOfficeTeamNameText} Access`
              // }
              allMembersImagedata={getAllMembersImageData()}
              image={""}
              toggle={(data) => {
                userType !== "liaison" ? toggle(data) : handleLiaisonConfirm();
              }}
            />
          </Modal>
          <Modal
            onClose={() => setOpenInfoModal(false)}
            open={openInfoModal}
            width="500px"
            minWidth="500px"
            mdlStyle={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
            modalContainerClass="liaison_confirmation_modal"
          >
            <div className="content_container">
              <HomePagePopupIcon />
              <p>Please select at least one family member</p>
              <ArrowButton
                onClick={() => {
                  setOpenInfoModal(false);
                  setDisableAccessModal(false);
                }}
                type={"next"}
                label={"Sure, Continue"}
                styleProp={{
                  borderRadius: "15px",
                }}
              />
            </div>
          </Modal>
        </>
      )}
    </Observer>
  );
});

export default AddedLiaisonOfficer;
